import { Dispatch, SetStateAction } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import useCreateChurnRequest from 'modules/billing/hooks/churn_request/useCreateChurnRequest'

import { CHURN_REASONS_WITHOUT_SECONDARY } from 'modules/billing/components/DeleteCompanyAction/_DeleteCompanyModal/constants'
import type {
  FormData,
  ValidStepChurn
} from 'modules/billing/components/DeleteCompanyAction/_DeleteCompanyModal/types'

type FooterProps = {
  step: ValidStepChurn
  setStep: Dispatch<SetStateAction<ValidStepChurn>>
  getValue: (attr: keyof FormData) => string | undefined
  onClose: () => void
}

const Footer = ({ step, setStep, getValue, onClose }: FooterProps) => {
  const { create, loading } = useCreateChurnRequest()
  const mainChurnReason = getValue('mainReason')
  const secondaryChurnReason = getValue('secondaryReason')
  const isFormValid = mainChurnReason && secondaryChurnReason

  const onSubmit = async () => {
    if (!mainChurnReason) return

    await create({
      mainChurnReason,
      secondaryChurnReason
    })

    onClose()
  }

  const goBack = () => {
    setStep('first-step')
  }

  switch (step) {
    case 'first-step':
      return (
        <Button
          type="secondary"
          onClick={async () => {
            if (mainChurnReason && CHURN_REASONS_WITHOUT_SECONDARY.includes(mainChurnReason)) {
              await onSubmit()
            } else {
              setStep('second-step')
            }
          }}
          disabled={!mainChurnReason}
        >
          {i18n.t('billing.completed.cta')}
        </Button>
      )
    case 'second-step':
      return (
        <>
          <Button type="secondary" onClick={goBack} iconName="arrow-left" />
          <Button type="negative" onClick={onSubmit} disabled={!isFormValid} loading={loading}>
            {i18n.t('billing.churn_request.buttons.cancel_subscription')}
          </Button>
        </>
      )
    default:
      return null
  }
}

export default Footer
